import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/techstars_white.png")